import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      width="201"
      height="204"
      fill="currentColor"
      viewBox="0 0 201 204"
    >
      <path d="M2.26268 96.5327c-3.016905 3.0652-3.016905 8.0373 0 11.1083l27.82822 28.285c7.258-7.38 7.3041-19.294.0973-26.618l-7.2016-7.323 77.3484-78.6229 7.207 7.3237c7.201 7.3186 18.926 7.2727 26.184-.1071L105.898 2.29885c-3.017-3.065134-7.9089-3.065134-10.9258 0L2.26268 96.5327ZM198.453 107.467c3.017-3.07 3.017-8.0425 0-11.1077l-27.828-28.2849c-7.258 7.3798-7.304 19.2935-.097 26.6121l7.202 7.3285-77.354 78.623-7.2017-7.324c-7.2067-7.323-18.926-7.278-26.1891.102l27.8282 28.285c3.0169 3.065 7.9086 3.065 10.9306 0l92.709-94.234Z" />
      <path d="M54.8203 102.025c0-1.336 1.05-2.4373 2.3663-2.4781.1127-.0051.2254-.0102.3125-.0153.2407-.0102.4763-.0204.712-.0357 21.2924-1.3465 38.3387-18.6663 39.6704-40.3109.0103-.2397.0256-.4743.0359-.714.0051-.0969.0102-.2091.0102-.3367.041-1.3362 1.1217-2.4021 2.4384-2.4021 1.321 0 2.402 1.0659 2.443 2.4021.005.1276.005.2398.01.3367.01.2397.026.4743.036.714 1.332 21.6446 18.378 38.9644 39.67 40.3109.236.0153.472.0255.712.0357.088.0051.195.0102.313.0153 1.316.0408 2.361 1.1371 2.361 2.4781 0 1.337-1.045 2.433-2.361 2.479-.118.005-.225.01-.313.01-.24.011-.476.026-.712.041-21.297 1.347-38.338 18.666-39.67 40.311-.01.24-.026.474-.036.709-.005.102-.01.214-.01.342-.041 1.341-1.122 2.407-2.443 2.407-1.3167 0-2.3974-1.066-2.4384-2.407-.0051-.128-.0051-.24-.0102-.342-.0103-.235-.0256-.469-.0359-.709-1.3317-21.645-18.3729-38.964-39.6704-40.311-.2357-.015-.4713-.03-.712-.041-.0871 0-.1998-.005-.3125-.01-1.3163-.046-2.3663-1.137-2.3663-2.479Z" />
    </svg>
  );
};
